import { useState } from "react";
import { Box, Typography } from "@mui/material";
import {
  CustomTabPanel,
  StyledTab,
  StyledTabs,
  a11yProps,
} from "../Common/UI/TabPanel";

import { HeaderStyle } from "../Common/styles/header";
import { useQuery } from "../../utils/hooks";
// import WelcomeEmail from "../StudySettings/ThemeSettings/WelcomeEmail";
import LandingPageBuilder from "../StudySettings/Tabs/LandingPageBuilder";
import PlatformUrlLoader from "./PlatformUrlLoader";
import PlatformUrlSetter from "./PlatformUrlSetter";
// import { platformLanguages } from "../../utils/language";
import FlyerCard from "../StudySettings/FlyerCard";
import Languages from "./Tabs/Languages";
import EmailConfig from "../StudySettings/ThemeSettings/EmailConfig";
import { platformAdminPermissions } from "../../utils/roles";
import { useAppSelector } from "../../Redux/hooks";

const PlatformSettings = () => {
  const queryType = useQuery().get("type");
  const platformPermissions = useAppSelector(
    (state) => state.user.platformPermissions
  );
  const [type, setType] = useState(queryType ?? "flyer");
  const [urlLoaded, setUrlLoaded] = useState<boolean>(false);

  const handleChange = (_: any, newValue: string) => {
    setType(newValue);
  };

  const [hasAccess] = useState(
    platformPermissions.includes(platformAdminPermissions.managePlatform)
  );

  return urlLoaded ? (
    <>
      <Box sx={HeaderStyle}>
        <Typography variant="h2" color="text.primary">
          Platform Settings
        </Typography>
      </Box>
      <>
        <Box sx={{ borderBottom: 1, borderColor: "#E5E7EB" }}>
          <StyledTabs value={type} onChange={handleChange}>
            <StyledTab label="Flyer" value="flyer" {...a11yProps(0)} />
            <StyledTab label="Languages" value="languages" {...a11yProps(1)} />
            {/* <StyledTab
              label="Participant Welcome Email"
              value="welcome_email"
              {...a11yProps(2)}
            /> */}
            <StyledTab
              label="Email Config"
              value="email_config"
              {...a11yProps(2)}
            />
            <StyledTab
              label="Landing Page Builder"
              value="landing_page_builder"
              {...a11yProps(3)}
            />
          </StyledTabs>
        </Box>
        <Box sx={{ p: 3, overflow: "auto", height: "calc(100vh - 181px)" }}>
          <CustomTabPanel value={type} index={"flyer"}>
            <FlyerCard />
          </CustomTabPanel>
          <CustomTabPanel value={type} index={"languages"}>
            <Languages canEdit={hasAccess} />
          </CustomTabPanel>
          {/* <CustomTabPanel value={type} index={"welcome_email"}>
            <WelcomeEmail canEdit={hasAccess} languages={platformLanguages} />
          </CustomTabPanel> */}
          <CustomTabPanel value={type} index={"email_config"}>
            <EmailConfig canEdit={hasAccess} />
          </CustomTabPanel>
          <CustomTabPanel value={type} index={"landing_page_builder"}>
            <LandingPageBuilder languages={[]} canEdit={hasAccess} />
          </CustomTabPanel>
        </Box>
      </>
      <PlatformUrlSetter type={type} />
    </>
  ) : (
    <PlatformUrlLoader setType={setType} setUrlLoaded={setUrlLoaded} />
  );
};

export default PlatformSettings;
